import Event from "@/types/Event";
import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { useCategoriesStore } from "./categories";
import getEvents from "@/api/requests/getEvents";
import { useProducersStore } from "./producers";
import getEventById from "@/api/requests/getEventById";
import { useSnackbar } from "./snackbar";

export const useEventsStore = defineStore("events", () => {
  const list = ref<Event[]>([]);

  const selected = ref<Event | null>(null);

  const categories = useCategoriesStore();

  const producers = useProducersStore();

  const loading = ref(false);

  const hasBiometricAccess = computed(() => {
    if (selected.value === null) return false;

    if (selected.value?.access_type === undefined) return false;

    return ["biometric", "hybrid"].includes(selected.value.access_type);
  });

  async function fetchEvents() {
    try {
      loading.value = true;

      const response = await getEvents(1, producers.selected, categories.selected.id);

      list.value = response.data.data;
    } catch {
      useSnackbar().show("Erro ao atualizar eventos", "error");
    } finally {
      loading.value = false;
    }
  }

  async function selectEventById(id: string) {
    selected.value = await getEventById(id);
  }

  watch(() => [categories.selected, producers.selected], fetchEvents);

  return {
    list,
    loading,
    selected,
    hasBiometricAccess,
    fetchEvents,
    selectEventById,
  };
}, { persist: true });
